import styled from '@emotion/styled'
import {theme} from '../../../theme'

export const BannerWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.space[2.5]};
  padding: ${theme.space[3]};
  margin-bottom: ${theme.space[4]};
  background: ${theme.colors.bg.secondary};
  border: 1px solid ${theme.colors.border.default};
  border-radius: ${theme.radii.lg};
`

export const BannerMessage = styled.div`
  font-weight: ${theme.fontWeights.semibold};
  color: ${theme.palette.warning[700]};
`

// "What you entered" sizes to its own content (capped so a long address
// can't crowd out the Recommended column) instead of a fixed 30/70 split;
// Recommended then takes whatever space is left.
export const ColumnsRow = styled.div`
  display: grid;
  grid-template-columns: fit-content(320px) 1fr;
  gap: ${theme.space[3]};
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.space[1]};
  padding: ${theme.space[3]};
  border: 1px solid ${theme.colors.border.default};
  border-radius: ${theme.radii.lg};
`

export const RecommendedColumn = styled(Column)`
  display: grid;
  grid-template-columns: ${({hasMap}) => (hasMap ? '1fr 1fr' : '1fr')};
  gap: ${theme.space[3]};
`

export const RecommendedDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.space[1]};
`

export const ColumnLabel = styled.div`
  font-weight: ${theme.fontWeights.semibold};
`

export const MapImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: ${theme.radii.md};
`

export const TokenText = styled.span`
  font-weight: ${({changed}) =>
    changed ? theme.fontWeights.semibold : theme.fontWeights.regular};
  background-color: ${({changed}) =>
    changed ? theme.palette.warning[100] : 'transparent'};
  border-radius: ${theme.radii.sm};
  padding: ${({changed}) => (changed ? `0 ${theme.space[0.5]}` : 0)};
`
